import { render } from "./App.vue?vue&type=template&id=4eef27d2"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4eef27d2&lang=css"

import exportComponent from "/Applications/MAMP/htdocs/fantasy-nft/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__